import type { ClientSummaryResponse } from '@contracts/client/ClientSummaryListResponse';
import type { AutocompleteRenderInputParams } from '@mui/material/Autocomplete';
import { TextInput } from '@src/common/components/TextInput';
import { ClientFilter } from '@src/permits/permitSearch/filters/ClientFilter';
import type { SearchPermitFilters } from '@src/permits/services/PermitApplicationClient';
import { useTranslation } from 'react-i18next';

interface Props {
  onFilterChange: (filters: SearchPermitFilters) => void;
  value: {
    name: string;
    value: string;
  }[];
  options?: ClientSummaryResponse[];
}

export const BillToClientFilter = ({
  onFilterChange,
  value,
  options,
}: Props) => {
  const BillToClientInput = (params: AutocompleteRenderInputParams) => {
    const { t } = useTranslation();
    const billToClientLabel = t('fields.billTo');
    return <TextInput {...params} label={billToClientLabel} />;
  };
  return (
    <ClientFilter
      onFilterChange={onFilterChange}
      value={value}
      options={options}
      renderInput={BillToClientInput}
      filterKey="billTo"
    />
  );
};
